<template>
  <div class="fc">
    <div class="xxqk">
      <h3 class="xxqk_tit">学习情况</h3>
      <img
        src="../../assets/close.png"
        class="xxqk_close"
        alt=""
        @click="$emit('closeLayer')"
      />
      <div class="xxqk_table">
        <div class="xxqk_tabltTop flex">
          <div class="xxqk_td">考核项</div>
          <div class="xxqk_td flex_item">满分</div>
          <div class="xxqk_td flex_item">得分</div>
        </div>
        <div
          v-for="(info, index) of this.learningInfo.infos"
          :key="index"
          class="xxqk_tabltBody flex"
        >
          <div class="xxqk_td flex">
            <p class="xxqk_info">{{ info.title }}</p>
            <div v-if="info.title == '视频学习'" class="flex_item">
              <span
                v-if="
                  info.alreadyStudySum != null &&
                  parseInt(info.alreadyStudySum) > 0
                "
                class="xxqk_time"
                >{{ timeFormat(parseInt(info.alreadyStudySum)) }}</span
              >
              <span
                v-if="!info.finish"
                class="xxqk_status"
                >未完成</span
              >
            </div>
            <div v-if="info.title == '学习感悟'" class="flex_item">
              <span
                v-if="!info.finish"
                class="xgw"
                @click="writeImpression"
                >填写</span
              >
              <span
                v-if="info.finish"
                class="xgw"
                >已完成</span
              >
            </div>
          </div>
          <div class="xxqk_td flex_item">{{ info.credit }}</div>
          <div class="xxqk_td flex_item">{{ info.realScore }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    learningInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    writeImpression() {
      this.$emit('writeImpression', this.learningInfo.courseId);
    },
    timeFormat(seconds) {
      let timeStr = "";
      if (seconds >= 0) {
        let hour = Math.floor(seconds / 3600);
        let min = Math.floor(seconds / 60) % 60;
        let sec = Math.floor(seconds % 60);
        // 拼接小时数
        if (hour > 0) {
          timeStr = hour + "小时";
        }
        // 拼接分钟数
        if (min > 0) {
          if (min < 10) {
            timeStr += `0${min}分`;
          } else {
            timeStr += `${min}分`;
          }
        }
        // 拼接秒数
        if (sec > 0) {
          if (sec < 10) {
            timeStr += `0${sec}秒`;
          } else {
            timeStr += `${sec}秒`;
          }
        }
      }
      return timeStr;
    },
  },
};
</script>

<style scoped>
.fc {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: block;
}

.xxqk {
  padding: 60px 0px;
  padding-top: 32px;
  position: relative;
  background-color: #fff;
  border-radius: 8rpx;
  margin: 0 auto;
  margin-top: 235px;
  width: 900px;
  box-sizing: border-box;
}

.xxqk_tit {
  font-size: 28px;
  font-weight: 600;
  color: #222;
  line-height: 40px;
  text-align: center;
}

.xxqk_close {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 32px;
  right: 40px;
  cursor: pointer;
}

.xxqk_table {
  margin-top: 32px;
  margin-left: 60px;
  margin-right: 60px;
}

.xxqk_tabltTop {
  background-color: #e1e6eb;
  color: #222222;
  font-size: 16px;
  font-weight: 400;
  line-height: 74px;
  height: 74px;
}

.xxqk_td:first-child {
  width: 360px;
}

.xxqk_td {
  text-align: center;
}

.xxqk_info {
  font-size: 16px;
  color: #222;
  font-weight: 400;
  margin-right: 10px;
}

/* .xxqk_content {
  font-size: 16px;
  color: #222;
  font-weight: 400;
  margin-right: 10px;
} */

.xxqk_time {
  font-size: 16px;
  color: #222;
  font-weight: 400;
  margin-right: 10px;
}

.xxqk_status {
  font-size: 14px;
  color: #ff4343;
  line-height: 20px;
  margin-left: 10px;
}

.xxqk_table {
  border-bottom: 1px solid #e1e6eb;
}

.xxqk_tabltBody {
  border-left: 1px solid #e1e6eb;
}

.xxqk_tabltBody .xxqk_td {
  border-right: 1px solid #e1e6eb;
  border-top: 1px solid #e1e6eb;
  height: 72px;
  line-height: 72px;
}

.xgw {
  font-size: 14px;
  color: #fff;
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  display: inline-block;
  background-color: #003399;
  cursor: pointer;
}

.xxqk_tabltBody .xxqk_td:first-child {
  padding-left: 63px;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.flex_item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}
</style>